import React, { Component } from "react";
import { Container, Row, Col, Badge, Alert } from "reactstrap";

//Import Components
import SectionTitle from "../../components/Shared/SectionTitle";
import Feature from "../../components/Shared/Feature";

// import images
import mobile from "../../assets/images/software/dijitalsiramatiksalon.png";

class Features extends Component {
  constructor(props) {
    super(props);
    this.imageRef = React.createRef();
    this.handleScroll = this.handleScroll.bind(this);
  }

  state = {
    features: [
      {
        id: 1,
        icon: "uil uil-qrcode-scan h2 text-primary",
        title: "QR Kod ile Hızlı Kayıt",
        description:
          "Müşterileriniz QR kod okutarak saniyeler içinde sıra alabilir. Manuel kayıt seçeneği de mevcuttur.",
      },
      {
        id: 2,
        icon: "uil uil-monitor h2 text-primary",
        title: "Canlı TV Display",
        description:
          "Bekleme salonlarında gösterilen büyük ekranlarda sıra numaraları ve çağrılar canlı olarak görüntülenir.",
      },
      {
        id: 3,
        icon: "uil uil-users-alt h2 text-primary",
        title: "Çoklu Kullanıcı Desteği",
        description:
          "Yönetici, personel ve müşteri rolleri ile herkes kendi ihtiyacına göre sistemi kullanabilir.",
      },
      {
        id: 4,
        icon: "uil uil-palette h2 text-primary",
        title: "Özelleştirilebilir Tasarım",
        description:
          "Logo, renk teması ve hoş geldin mesajları ile kurumunuzun kimliğine uygun hale getirin.",
      },
      {
        id: 5,
        icon: "uil uil-chart-line h2 text-primary",
        title: "Detaylı İstatistikler",
        description:
          "Günlük, haftalık ve aylık raporlarla işlem hacminizi ve bekleme sürelerinizi analiz edin.",
      },
      {
        id: 6,
        icon: "uil uil-sync h2 text-primary",
        title: "Akıllı Transfer Sistemi",
        description:
          "Personeller arasında hasta transferi yapabilir, acil durumlarda öncelik verebilirsiniz.",
      },
      {
        id: 7,
        icon: "uil uil-mobile-android h2 text-primary",
        title: "Mobil Uyumlu",
        description:
          "Tablet, telefon ve masaüstü bilgisayarlarda sorunsuz çalışır. PWA desteği ile uygulama gibi kullanın.",
      },
      {
        id: 8,
        icon: "uil uil-bolt-alt h2 text-primary",
        title: "Hızlı ve Güvenilir",
        description:
          "Bulut tabanlı altyapı ile 7/24 erişilebilir, yüksek performanslı sistem.",
      },
    ],
  };

  componentDidMount() {
    var featureboxes = document.getElementsByName("featurebox");
    for (var i = 0; i < featureboxes.length; i++) {
      featureboxes[i].classList.add("mt-5");
    }
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll(); // Initial call
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll() {
    if (this.imageRef.current) {
      const rect = this.imageRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Calculate opacity based on scroll position
      // Image starts fully visible when it enters viewport
      // Fades out as user scrolls down
      let opacity = 1;
      
      if (rect.top < windowHeight && rect.top > -rect.height) {
        // Image is in viewport
        const scrollProgress = (windowHeight - rect.top) / (windowHeight + rect.height);
        opacity = Math.max(0, 1 - scrollProgress * 1.5); // Fade out faster
      } else if (rect.top >= windowHeight) {
        // Image hasn't entered viewport yet
        opacity = 1;
      } else {
        // Image has scrolled past
        opacity = 0;
      }
      
      this.imageRef.current.style.opacity = opacity;
      this.imageRef.current.style.transform = `translateY(${rect.top * 0.3}px)`; // Parallax effect
    }
  }
  render() {
    return (
      <React.Fragment>
        <Container id="neden-dijital-siramatik">
          {/* Render Section Title */}
          <SectionTitle
            title="Neden Dijital Sıramatik?"
          />

          {/* feature box */}
          <Feature featureArray={this.state.features} isCenter={true} />
        </Container>

        {/* Full width parallax image section */}
        <div 
          className="position-relative overflow-hidden"
          style={{ 
            width: "100%", 
            marginTop: "5rem",
            marginBottom: "5rem"
          }}
        >
          <img 
            ref={this.imageRef}
            src={mobile} 
            className="d-block w-100" 
            alt=""
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
              transition: "opacity 0.1s ease-out",
              willChange: "opacity, transform"
            }}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default Features;
